export default "__VITE_ASSET__BjgFT4Sh__"